import { MultiValuedList } from '../../MultiValuedList'
import { UserMultiValuedListItem } from '../UserMultiValuedListItem'
import { UserMultiValuedListMoreItem } from '../UserMultiValuedListMoreItem'

import { filterByFullname } from './UserMultiValuedList.utils'

function UserMultiValuedList({
  Item = UserMultiValuedListItem,
  MoreItem = UserMultiValuedListMoreItem,
  filter = filterByFullname,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default UserMultiValuedList
